(function ($, Cobalt, undefined) {
    Cobalt.RatingForm = function ($ratingForm) {
        var that = this;
        this.ratingsType = $ratingForm.attr("data-rating-form-type");
        this.ratingForm = $ratingForm;
        this.ratingCount = $ratingForm.attr("data-rating-count");
        this.ratingAverage = $ratingForm.attr("data-rating-average");
        this.ratingSum = $ratingForm.attr("data-rating-sum");
        this.ratingPositive = $ratingForm.attr("data-rating-countpositive");
        this.ratingNegative = $ratingForm.attr("data-rating-countnegative");
        this.ratingForm.unbind("submit");
        this.showRatingDetails = false;

        // provide instant feedback on liked comments
        if (this.ratingsType === "like") {
            var likeSpan = $ratingForm.find("span.like");
            var userId = likeSpan.attr("data-user-id");
            if (userId == Cobalt.User.userID) {
                likeSpan.find('input').hide();
                likeSpan.addClass("user-owned");
                likeSpan.attr('title', 'You may not vote on your own content');
            }

            $ratingForm.find("#field-like").click(function () {
                var numLikesElem = $ratingForm.find(".num-likes");
                var $ratingSum = $ratingForm.find('.rating-sum');
                var likeField = $ratingForm.find("#field-like");
                if (likeField.length > 0) {
                    var $parent = likeField.parent();

                    if (likeField.hasClass("liked")) {
                        numLikesElem.text(parseInt(numLikesElem.text()) - 1);
                    } else {
                        numLikesElem.text(parseInt(numLikesElem.text()) + 1);
                    }
                }
            });

        }

        $ratingForm.find('.rating-sum.rating-average').click(function () {
            if (!that.showRatingDetails) {
                $(this).html('<span class="rating-sum rating-average-ratingPositive">+' + that.ratingPositive + '</span><span class="rating-sum rating-average-ratingNegative">-' + that.ratingNegative + '</span>');
                $(this).attr('title', 'Click to hide breakdown').tooltip();
                that.showRatingDetails = true;
            } else {
                $(this).html('<span class="rating-sum ">' + (that.ratingSum > 0 ? '+' : '') + that.ratingSum + '</span>');
                $(this).attr('title', 'Click to see breakdown').tooltip();
                that.showRatingDetails = false;
            }
        });

        $ratingForm.find('.rating-up,.rating-down').each(function () {
            var userID = $(this).attr('data-user-id');

            if (userID == Cobalt.User.userID) {
                $(this).addClass('rating-disabled').addClass('rating-ownpost');
                $(this).find('input').attr('title', 'You may not vote on your own content').tooltip();
            }
        });
        $ratingForm.find('.rating-disabled.rating-login input').click(function () {
            //Cobalt.Auth.showLoginModal(window.location.href);
            return false;
        });
        $ratingForm.find('.rating-disabled.rating-ownpost input').click(function () {
            return false;
        });

        if (!Cobalt.User.IsAuthenticated) {
            $ratingForm.find('.need-login').click(function () {
                //Cobalt.Auth.showLoginModal();
                return false;
            });
        }

        this.ratingForm.ajaxForm({
            type: 'post',
            dataType: 'json',
            beforeSubmit: function () {
                that.ratingForm.find("input").each(function () {
                    $(this).attr("disabled", "disabled");
                });
            },
            success: function (result) {
                that.ratingForm.find("input").each(function () {
                    $(this).removeAttr("disabled");
                });

                var entityTypeID = result.EntityTypeID;
                var entityID = result.EntityID;
                var value = result.RatingValue;
                that.ratingCount = result.RatingAverage.Count;
                that.ratingAverage = result.RatingAverage.Average;
                that.ratingSum = result.RatingAverage.Sum;
                that.ratingPositive = result.RatingAverage.CountPositive;
                that.ratingNegative = result.RatingAverage.CountNegative;
                that.addCookieValue(entityTypeID, entityID, value, result.Timestamp);
            }
        });

        this.applyRatings = function (entityTypeID, entityID, value, timestamp) {
            if (value != undefined) {
                switch (this.ratingsType) {
                    case "five-star":
                        this.selectStars(value, true, entityTypeID, entityID);
                        break;
                    case "like":
                        this.setLike(value);
                        break;
                    case "thank":
                        this.setThank(value, entityTypeID, entityID);
                        break;
                    case "up-down":
                        this.upDown(value, entityTypeID, entityID);
                        break;
                    default:
                        this.selectStars(value, false, entityTypeID, entityID);
                        break;
                }
            }
        };

        this.parseRatingsCookie = function () {
            var entityTypeID = this.ratingForm.attr("data-entity-type-id");
            var entityID = this.ratingForm.attr("data-entity-id");
            var ratingValue = Cobalt.Rating.getRatingsValue(entityTypeID, entityID);
            var timestamp = Cobalt.Rating.getRatingsTimestamp(entityTypeID, entityID);
            this.applyRatings(entityTypeID, entityID, ratingValue, timestamp);
        };

        this.setRatingsCookie = function (cookieValue) {
            var options = { domain: Cobalt.Utils.getCurrentDomain(), path: "/", skipEncoding: true, expires: 700 };
            $.cookie("Ratings", cookieValue, options);
            Cobalt.User.Ratings = cookieValue;
            this.parseRatingsCookie();
        };

        this.selectStars = function (value, updateStars) {
            if (updateStars) {
                var currentRating = this.ratingForm.find("li.current-rating");
                currentRating[0].style.width = ((value / 5) * 100) + "%";
            }
            this.ratingForm.find("input").attr("title", L.Global.Ratings.YouRatedThis(value, this.ratingAverage, this.ratingCount));
        };

        this.upDown = function (value, entityTypeID, entityID) {
            $('div.rating-form').each(function () { // For each ratable entity form on the page
                var $ratingForm = $(this); // Grab the ratable entity form element
                var entityField = $ratingForm.find('input#field-ratableEntity'); // Hidden field that contains the EntityTypeID:EntityID
                var entityFieldVals = entityField.val().split(':'); // Split the EntityTypeID:EntityID string into an easy to use array
                var eTID = entityFieldVals[0]; // Grab the EntityTypeID
                var eID = entityFieldVals[1]; // Grab the EntityID

                if (entityTypeID == eTID && entityID == eID) { // If the rating form is for the same entity as the one being voted on
                    var $upRatingElem = $ratingForm.find('div.rating-up'); // Grab the up rating element
                    var $sumRatingElem = $ratingForm.find('div.rating-sum'); // Grab the rating summary element
                    var $downRatingElem = $ratingForm.find('div.rating-down'); // Grab the down rating element

                    var ratingSum = that.ratingSum; // Pull the rating sum (The value we display) from the parent Cobalt.RatingForm object.

                    // Update the tooltip text for the rating
                    if (value != undefined) { // If there is a rating value (the value the user chose as their vote)
                        switch (parseInt(value)) {
                            case 1: // User up-voted the entity
                                // Add the ratingSelected class to the up rating element and set the title text for undoing their vote.
                                $upRatingElem.addClass('ratingSelected')
                                             .find('input')
                                             .attr('title', 'Click to undo your vote');
                                $downRatingElem.removeClass('ratingSelected')
                                             .find('input')
                                             .attr('title', 'Vote Down');
                                break;
                            case -1: // User down-voted the entity
                                // Add the ratingSelected class to the down rating element and set the title text for undoing their vote.
                                $downRatingElem.addClass('ratingSelected')
                                               .find('input')
                                               .attr('title', 'Click to undo your vote');
                                $upRatingElem.removeClass('ratingSelected')
                                             .find('input')
                                             .attr('title', 'Vote Up');
                                break;
                            case 0: // No vote?
                                // Remove the rating selected class and set the text to a default text for the up/down vote elements
                                $upRatingElem.removeClass('ratingSelected')
                                             .find('input')
                                             .attr('title', 'Vote Up');

                                $downRatingElem.removeClass('ratingSelected')
                                             .find('input')
                                             .attr('title', 'Vote Down');
                                break;
                            default:
                                break;
                        }
                        $ratingForm.find('.tip').tooltip();
                    }

                    if (parseInt(ratingSum) >= 0) { // If the rating sum is greater than or equal to zero
                        // Remove the negative styling and add the positive styling
                        $sumRatingElem.removeClass('rating-average-ratingNegative')
                            .addClass('rating-average-ratingPositive');

                        // Set the element text
                        if (parseInt(ratingSum) == 0) {
                            $sumRatingElem.html(0);
                        } else {
                            $sumRatingElem.html('+' + ratingSum);
                        }
                    } else {
                        // Remove the positive styling and add the negative styling
                        $sumRatingElem.removeClass('rating-average-ratingPositive')
                            .addClass('rating-average-ratingNegative');
                        // Set the element text
                        $sumRatingElem.html(ratingSum);
                    }
                }
            });
        };


        this.addCookieValue = function (entityTypeID, entityID, ratingValue, timestamp) {
            var currentValues = $.cookie("Ratings");
            if (currentValues == null) {
                currentValues = "";
            }
            var currentRating = Cobalt.Rating.getRatingsValue(entityTypeID, entityID);
            if (currentRating == null) {
                var ratingForEntity = entityTypeID + "," + entityID + "," + ratingValue + ',' + timestamp + '|';
                currentValues += ratingForEntity;

                this.setRatingsCookie(currentValues);

            }
            else {
                if (this.ratingsType == "like" || this.ratingsType == "thank") { //special case for Like
                    Cobalt.Rating.removeRatingsValue(entityTypeID, entityID);
                } else {
                    Cobalt.Rating.setRatingsValue(entityTypeID, entityID, ratingValue, timestamp);
                }
                that.applyRatings(entityTypeID, entityID, ratingValue, timestamp);
            }
        };


        this.setLike = function (value) {
            var numLikesElem = this.ratingForm.find(".num-likes");
            var likeField = this.ratingForm.find("#field-like");
            if (likeField.length > 0) {
                var $parent = likeField.parent();

                if (likeField.hasClass("liked")) {
                    likeField.removeClass("liked");
                    $parent.removeClass("liked");
                    $parent.attr("title", "Click to like this");
                    $parent.tooltip();
                } else {
                    likeField.addClass("liked");
                    $parent.addClass("liked");
                    $parent.attr("title", "You like this.");
                    $parent.tooltip();
                }
            }
        };
        
        this.setThank = function (value, entityTypeID, entityID) {
            var numLikesElem = this.ratingForm.find(".num-likes");
            var likeField = this.ratingForm.find("#field-like");
            if (likeField.length > 0) {
                var $parent = likeField.parent();

                if (likeField.hasClass("liked")) {
                    likeField.removeClass("liked");
                    $parent.removeClass("liked");
                    $parent.attr("title", "Thank {0} for this post.".format($parent.data("display-name")));
                    $parent.tooltip();
                } else {
                    $parent.addClass("liked");
                    likeField.addClass("liked");
                    $parent.attr("title", "Remove thanks".format($parent.data("display-name")));
                    $parent.tooltip();
                }
            }
            if (value != undefined) {
                if (numLikesElem.parents(".j-like-modal").length < 1) {
                    var wrapper = $("<a href='" + Cobalt.Routes.Instance.CommentRatingModal(entityTypeID, entityID) + "' class='modal-link j-like-modal' data-title='Thanks'></a>");
                    numLikesElem.wrap(wrapper);
                    Cobalt.triggerHtmlInsert(numLikesElem.parents(".rating-form"));
                }
                else if (value === 0) {
                    numLikesElem.parents(".j-like-modal").remove();
                    this.ratingForm.find('div.b-rating-a').prepend("<span class='num-likes'>0</span>");
                } else {
                    numLikesElem.text(value);
                }

                if (numLikesElem.text() === "0") {
                    numLikesElem.text(value);
                }
            }
        };

        if (this.ratingsType == "social-like") {
            $(Cobalt.Social_Facebook).bind("facebookLoaded", function () {
                try {
                    FB.Event.subscribe('edge.create', function (href, widget) {
                        $ratingForm.submit();
                    });
                }
                catch (e) { }
            });

        }
    };

    Cobalt.Rating = {
        ratingsRoute: null,
        ratingForms: null,
        customRoute: null,
        initialize: function (ratingRouteOverride) {
                Cobalt.Rating.customRoute = ratingRouteOverride;

            this.updateElements();
        },
        updateElements: function () {
            var ratingForm = Cobalt.Rating.ratingForm = $("form.rating-form");
            if (ratingForm.length == 0) {
                return;
            }
            Cobalt.Rating.ratingForms = new Array();
            ratingForm.each(function (i, val) {
                var ratingFormObj = new Cobalt.RatingForm($(val));
                Cobalt.Rating.ratingForms[i] = ratingFormObj;
                if (Cobalt.User.IsAuthenticated && !Cobalt.Rating.userHasRatingsCookie()) {
                    var route = Cobalt.customRoute != null ? Cobalt.customRoute : Cobalt.Rating.ratingsRoute();
                    $.getJSON(route, null, function (result) {
                        if (result != "") {
                            ratingFormObj.setRatingsCookie(result);
                        }
                    });
                }

                if (Cobalt.Rating.userHasRatingsCookie()) {
                    ratingFormObj.parseRatingsCookie();
                }
            });
        },
        getRatingsValue: function (entityTypeID, entityID) {
            if (Cobalt.Rating.userHasRatingsCookie()) {
                var cookie = $.cookie("Ratings");
                var cookieValues = cookie.split("|");
                for (var i = 0; i < cookieValues.length; i++) {
                    var ratingValues = cookieValues[i].split(",");
                    // entityTypeID,entityID,ratingValue;entityTypeID,entityID,ratingValue;entityTypeID,entityID,ratingValue;etc.
                    if (ratingValues[0] == entityTypeID && ratingValues[1] == entityID) {
                        return ratingValues[2];
                    }
                }
            }
            return null;
        },
        getRatingsTimestamp: function (entityTypeID, entityID) {
            if (Cobalt.Rating.userHasRatingsCookie()) {
                var cookie = $.cookie("Ratings");
                var cookieValues = cookie.split("|");
                for (var i = 0; i < cookieValues.length; i++) {
                    var ratingValues = cookieValues[i].split(",");
                    // entityTypeID,entityID,ratingValue;entityTypeID,entityID,ratingValue;entityTypeID,entityID,ratingValue;etc.
                    if (ratingValues[0] == entityTypeID && ratingValues[1] == entityID) {
                        return parseInt(ratingValues[3], 10);
                    }
                }
            }
            return null;
        },
        removeRatingsValue: function (entityTypeID, entityID) {
            if (Cobalt.Rating.userHasRatingsCookie()) {
                var cookie = $.cookie("Ratings");

                var regex = new RegExp(entityTypeID + "," + entityID + ",\\d+\\|", "g");
                var newCookieValue = cookie.replace(regex, "");
                this.setRatingsCookie(newCookieValue);
            }
            return null;
        },
        setRatingsValue: function (entityTypeID, entityID, ratingsValue, timestamp) {
            if (Cobalt.Rating.userHasRatingsCookie()) {
                var cookie = $.cookie("Ratings");
                var cookieValues = cookie.split("|");
                for (var i = 0; i < cookieValues.length; i++) {
                    var ratingValuesArr = cookieValues[i].split(",");
                    if (ratingValuesArr[0] == entityTypeID && ratingValuesArr[1] == entityID) {
                        ratingValuesArr[2] = ratingsValue;
                        ratingValuesArr[3] = timestamp;
                    }
                    cookieValues[i] = ratingValuesArr.join(",");
                }
                Cobalt.Rating.setRatingsCookie(cookieValues.join("|"));
            }
        },
        setRatingsCookie: function (cookieValue) {
            var options = { domain: Cobalt.Utils.getCurrentDomain(), path: "/", skipEncoding: true, expires: 700 };
            $.cookie("Ratings", cookieValue, options);
            Cobalt.User.Ratings = cookieValue;
        },
        addCookieValue: function (entityTypeID, entityID, ratingValue, timestamp) {
            var currentValues = $.cookie("Ratings");
            if (currentValues == null) {
                currentValues = "";
            }
            var currentRating = Cobalt.Rating.getRatingsValue(entityTypeID, entityID);
            if (currentRating == null) {
                var ratingForEntity = entityTypeID + "," + entityID + "," + ratingValue + ',' + timestamp + '|';
                currentValues += ratingForEntity;
                Cobalt.Rating.setRatingsCookie(currentValues);
            }
            else {
                Cobalt.Rating.setRatingsValue(entityTypeID, entityID, ratingValue);
            }
        },
        userHasRatingsCookie: function () {
            return $.cookie("Ratings") != null;
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Rating.js